import React, { useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useRowEditor } from "../context/QuoteEditorContext"
import { RichTextEditor, RichTextView, isBlank } from "./RichText"

const FIELD = "long_description"
const TEXT  = "text-[12.5px] leading-[1.45] text-slate-600"

const LongDescription = ({ node }) => {
  const { dispatch } = useRowEditor()

  const value = node[FIELD] || ""
  const [editing, setEditing] = useState(false)

  const startEdit = event => {
    if (editing) return
    event?.stopPropagation?.()
    setEditing(true)
  }

  const commit = html => {
    dispatch({ type: "UPDATE_NODE", payload: { nodeUid: node._uid, field: FIELD, value: html } })
    setEditing(false)
  }

  if (editing) {
    return (
      <RichTextEditor
        value       = {value}
        placeholder = {I18n.t("quotes.builder.long_description.placeholder")}
        onDone      = {commit}
        onCancel    = {() => setEditing(false)}
        className   = {`mt-1 ${TEXT}`}
      />
    )
  }

  // Hover-only, so a quote being read back is not a column of invitations.
  if (isBlank(value)) {
    return (
      <button
        type      = "button"
        onClick   = {startEdit}
        className = "inline-flex items-center gap-1.5 border-0 bg-transparent p-0 text-[11.5px] italic text-slate-400 opacity-0 group-hover:opacity-100 hover:text-brand-600 cursor-text"
      >
        <FontAwesomeIcon icon="align-left" /> {I18n.t("quotes.builder.long_description.placeholder")}
      </button>
    )
  }

  return (
    <RichTextView
      value     = {value}
      onClick   = {startEdit}
      title     = {I18n.t("quotes.builder.long_description.click_to_edit")}
      className = {`${TEXT} cursor-text`}
    />
  )
}

export default LongDescription
